// extracted by mini-css-extract-plugin
export default {"body":"userEntryLayout_body__kivJR"};